import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { Spinner } from '@johnlewispartnership/wtr-ingredients/ingredients/Spinner';
import React from 'react';

import { loadable } from 'components/Skeleton/LoadableSkeleton';
import env from 'env/env';
import locator from 'utils/locator';
import { isEmbeddedInWebView } from 'utils/webview';
import CheckoutHeader from './CheckoutHeader/CheckoutHeader';

import styles from './styles.scss';

export interface CheckoutWrapperProps {
  title?: string;
  children?: React.ReactNode;
}

const GtmDebugSession = loadable(
  () =>
    import(
      /* webpackChunkName: "checkout-gtm" */
      'components/Analytics/GtmDebugSession'
    ),
  { fallback: null as never },
);

export function CheckoutWrapper({ title = 'Checkout', children }: CheckoutWrapperProps) {
  const isWebview = isEmbeddedInWebView();
  const queryParams = new URLSearchParams(locator.search);
  const shouldLoadGtmDebug =
    env.name !== 'prod' &&
    queryParams.get('id') &&
    queryParams.get('gtm_auth') &&
    queryParams.get('gtm_preview');

  return (
    <div className={styles.checkoutWrapper}>
      <CheckoutHeader />
      <main className={styles.background}>
        {!isWebview ? (
          <div className={styles.pageTitle}>
            <Typography styleAs="screenHeading" textStyle="heading-3xl" element="h1" noMargins>
              {title}
            </Typography>
          </div>
        ) : null}
        {children || <Spinner isActive className={styles.loadingIndicator} />}
        {shouldLoadGtmDebug && <GtmDebugSession />}
      </main>
    </div>
  );
}
